import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ActionButton from './action-button';

import { removeDomains } from '../../../common/actions/domain-management-action-creators';
import { removeSuggestedDomains } from '../../../common/actions/suggested-domains-action-creators';
import { DOMAIN_HIERARCHY_SUBDOMAIN } from '../../../common/constants/definitions';

export class RemoveDomainsButtonContainer extends Component{
    handleRemoveDomains = () => {
        const { selectedDomains } = this.props;
        const domains = selectedDomains.map( domain => domain.domainName );

        this.updateDomains( domains );
    }

    updateDomains = ( domains ) => {
        const { removeSuggestedDomains, selectedDomainFilter, type, removeDomains } = this.props;

        // only discovered subdomains utilizes a different call
        if( type === 'discovered' && selectedDomainFilter === DOMAIN_HIERARCHY_SUBDOMAIN ){
            removeSuggestedDomains( domains );
        }
        else{
            removeDomains( domains );
        }
    }

    render(){
        return (
            <ActionButton
                onClick={this.handleRemoveDomains}
                dataId="domain-management-remove-domains-button"
            >
                Remove Domains
            </ActionButton>
        );
    }
};

const mapDispatchToProps = {
    removeDomains,
    removeSuggestedDomains,
};

RemoveDomainsButtonContainer.propTypes = {
    removeDomains: PropTypes.func.isRequired,
    removeSuggestedDomains: PropTypes.func.isRequired,
    selectedDomainFilter: PropTypes.string.isRequired,
    selectedDomains: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
};

export default connect( null, mapDispatchToProps )( RemoveDomainsButtonContainer );
